import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { MarkMessageAsReadPayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useMarkMessageAsRead = () => {
  const { updateUnreadStateByCounterOverride } = useConversationQueryCache();
  const { messages } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async (payload: MarkMessageAsReadPayload) => messages.markMessageAsRead(payload),
    onSuccess: (result, payload) => {
      const { firstUnreadMessageId, unreadItems } = result.data;

      updateUnreadStateByCounterOverride(payload.conversationId, firstUnreadMessageId, unreadItems);
    },
  });

  return mutation;
};
